export default __webpack_public_path__ + "static/media/pp.1801e4c7.pdf";